<template>
    <div>
        <div class="vx-row order__head-col_inner">
            <div class="order__head-order vx-col">
                <vs-button>
                    {{ $t('Клиенты') }}
                </vs-button>
            </div>
            <div class="buttons"
                v-if="$store.state.auth.role === 'admin'"
            >
                <vs-button
                    @click="$router.push('/whatsapp/list-channel-whatsapp')"
                >{{ $t('channels') }}</vs-button>
            </div>
        </div>
        <br>
        <vs-table :max-items="15" pagination :data="listAllChat">
            <template slot="thead">
                <vs-th>
                    {{ $t('phone') }}
                </vs-th>
                <vs-th>
                    &nbsp;
                </vs-th>
                <vs-th>
                    {{ $t('personName') }}
                </vs-th>
                <vs-th>
                    {{ $t('whatsappFirstSentMess') }}
                </vs-th>
                <vs-th>
                    {{ $t('messageWhatsappLastText') }}
                </vs-th>
                <vs-th>
                    &nbsp;
                </vs-th>
                <vs-th v-if="['admin'].includes($store.state.auth.role)">
                    {{ $t('manager') }}
                </vs-th>
                <vs-th>
                    {{ $t('nameWhatsappChannel') }}
                </vs-th>
                <vs-th>
                    <!-- {{ $t('actions') }} -->
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr class="vs-table-filters">
                    <vs-td>
                        <vs-input class="w-full" v-model="searchPhone" @input="filterTable"></vs-input>
                    </vs-td>
                    <vs-td>

                    </vs-td>
                   <vs-td>
                        <vs-input class="w-full" v-model="searchName" @input="filterTable"></vs-input>
                    </vs-td>
                    <vs-td>
                        <!-- {{ $t('whatsappFirstSentMess') }} -->
                    </vs-td>
                    <vs-td>
                        <!-- {{ $t('messageWhatsappLastText') }} -->
                    </vs-td>
                    <vs-td>
                        &nbsp;
                    </vs-td>
                    <vs-td v-if="['admin'].includes($store.state.auth.role)">
                        <vs-input class="w-full" v-model="searchManager" @input="filterTable"></vs-input>
                    </vs-td>
                    <vs-td>
                        <vs-input class="w-full" v-model="searchChannel" @input="filterTable"></vs-input>
                    </vs-td>
                    <vs-td>
                        <!-- {{ $t('actions') }} -->
                    </vs-td>
                </vs-tr>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].userPhone">
                        {{ data[indextr].userPhone }}
                    </vs-td>
                    <vs-td :data="data[indextr].avatarUri">
                        <img
								v-if="data[indextr].avatarUri"
								:src="filePath(data[indextr].avatarUri)"
								alt=""
								class="avatarWhatsappListChat"
							>
							<feather-icon v-else icon="UserIcon" class="client-avatar" />
                    </vs-td>
                    <vs-td :data="data[indextr].userName">
                        {{ data[indextr].userName }}
                    </vs-td>
                    <vs-td :data="data[indextr].dateTime">
                        {{ datePeriod(data[indextr].dateTime) }}
                    </vs-td>
                    <vs-td :data="data[indextr].text">
                        <div v-html="short(data[indextr].text, 150)">
                        </div>
                    </vs-td>
                    <vs-td :data="data[indextr].dateTime">
                        <div class="w-full text-right">
                            <div v-if="data[indextr].statusText == 'inbound' && data[indextr].numUnreadMessages > 0">
                                <span class="counter danger">{{ data[indextr].numUnreadMessages }}</span>
                            </div>
                            <img
                                v-else
                                :src="showStatusMess(data[indextr].statusText)"
                                width="20" height="20"
                                style="float: right;"
                            >
                            </div>
                    </vs-td>
                    <vs-td  v-if="['admin'].includes($store.state.auth.role)" :data="data[indextr].userManager">
                        {{ data[indextr].userManager }}
                    </vs-td>
                    <vs-td :data="data[indextr].channelName">
                        {{ data[indextr].channelName }}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="flex justify-center">
                            <vs-button
                                size="small"
                                color="#626262"
                                type="flat"
                                icon-pack="feather"
                                @click="openChatWhatsapp(data[indextr].id)"
                                icon="book-open"
                            >
                                <feather-icon icon="BookOpenIcon"></feather-icon>
                            </vs-button>
                        </div>
                    </vs-td>    
                </vs-tr>
            </template>
        </vs-table>
    </div>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";

    import moment from 'moment';
    import date from "@/assets/configs/date.js";

    import debounce from 'debounce'

    export default {
        name: "DashboardWhatsapp",
        mixins: [databaseManager, notifier],
        components: {

        },
        data() {
            return {
                listAllChat: {},
                editChatResponseActive: false,
                searchPhone: '',
                searchName: '',
                searchManager: '',
                searchChannel: '',
            };
        },
        methods: {
            openChatWhatsapp(idChat) {
                const url = `/whatsapp/open-chat-whatsapp/${idChat}`;
				window.open(url);
            },
            filePath(file) {
                if (!file) {
                    return;
                }

                const fileName = file.toLowerCase();
                return fileName;
            },
            filterTable:  debounce(function (e) {
                let options = '?';
                if(this.searchName.length > 0) options += 'filter[name]='+this.searchName+'&'
                if(this.searchManager.length > 0) options += 'filter[manager]='+this.searchManager+'&'
                if(this.searchChannel.length > 0) options += 'filter[channel]='+this.searchChannel+'&'
                if(this.searchPhone.length > 0) options += 'filter[phone]='+this.searchPhone
                this.viewAllChatWhatsapp(options);
            }, 500),
            showStatusMess(status) {
                if(status =='read') {
                    return require('@/assets/images/whatsapp/read_w.png');
                    // return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" style="font-size: 20px; height: 20px; width: 20px; color: rgb(0, 172, 193) !important; caret-color: rgb(0, 172, 193) !important;"><path d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z"></path></svg>';
                }
                if(status =='delivered') {
                    return require('@/assets/images/whatsapp/delivered_w.png');
                    // return '<span data-v-eed3e000="" aria-hidden="true" class="v-icon notranslate theme--light" style="font-size: 20px; height: 20px; width: 20px; color: rgb(158, 158, 158); caret-color: rgb(158, 158, 158);"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg" style="font-size: 20px; height: 20px; width: 20px;"><path d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z"></path></svg></span>';
                }
                if(status =='sent') {
                    return require('@/assets/images/whatsapp/sent_w.png');
                }
                if(status =='inbound') {
                    return require('@/assets/images/whatsapp/inbound_w.png');
                }
                if(status =='error') {
                    return require('@/assets/images/whatsapp/error_w.png');
                }
            },
            datePeriod(dateTime, status = 'delivered') {
                if((status != 'delivered' && status == 'sent' && status == 'read') || status == 'inbound' || status == 'error') {
                    return ' ';
                }
                if(dateTime == '1970-01-01 01:00:00') {
                    return '---';
                }
                let dataNow = moment();
                let dayNow = dataNow.format("DD");
                let monthNow = dataNow.format("MM");
                let yearNow = dataNow.format("YYYY");


                const dateMoment = moment(dateTime);
                const month = this.$t(date.months[dateMoment.month()]);
                const year = dateMoment.format("YYYY");
                const m = dateMoment.format("MM");
                const d = dateMoment.format("DD");
                if(d == dayNow && m == monthNow && year == yearNow) {
                    return dateMoment.format("HH:mm:ss");
                }

                let dateYesterday = moment(dataNow.subtract(1, 'days').format('YYYY-MM-DD') + ' 00:00:00');
                
                if(dateYesterday.unix() < dateMoment.unix()) {
                    return this.$t("yesterdayDay");
                }
                // return `${month} ${year}`;
                return dateMoment.format("DD.MM.YYYY");
            },
            short(str, maxlen) {
                str = str.replace(/(<([^>]+)>)/gi, '');
                if(str.length <= maxlen) {
                    return str;
                } else {
                    return str.slice(0, maxlen) + ' ...'
                }
            },
            async viewAllChatWhatsapp(options) {
                this.listAllChat = await this.dbviewAllChatWhatsapp(options);
            },
        },
        async mounted() {
            try {
                 await this.viewAllChatWhatsapp();
            } catch(e) {
                this.notifyError(e.message);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .avatarWhatsappListChat {
        max-width: 30px;
        max-height: 30px;
        border-radius: 100%;
    }
    .counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.danger {
			background-color: red;
			color: white;
			border-color: #f0ad4e;
		}
	}
</style>